// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"282":"bf33deff","496":"958afd0a"}[chunkId] + ".chunk.js";
};